module.exports = __webpack_public_path__ + "static/fonts/Nunito-ExtraLightItalic.0d0f0f6.woff";